import { GameFullResponse } from "../../types/gameFull";
import { PitchStatus } from "../../utils/tagQueue";
import { ActivePlateAppearance } from "./ActivePlateAppearance";
import { GameHistory } from "./GameHistory";

type PlateAppearanceFeedProps = {
  data: GameFullResponse;
  awayTeamColor: string;
  homeTeamColor: string;
  selectedActivityId?: string;
  selectedPlateAppearanceId?: string;
  /** Pitches whose tags are saving or queued */
  pitchStatuses?: ReadonlyMap<string, PitchStatus>;
  onSelectPitch?: (activityId: string) => void;
  onAddDetails?: (activityId: string) => void;
  onMatchupClick?: (plateAppearanceId: string) => void;
};

export const PlateAppearanceFeed = ({
  data,
  awayTeamColor,
  homeTeamColor,
  selectedActivityId,
  selectedPlateAppearanceId,
  pitchStatuses,
  onSelectPitch,
  onAddDetails,
  onMatchupClick,
}: PlateAppearanceFeedProps) => {
  const sharedProps = {
    data,
    awayTeamColor,
    homeTeamColor,
    selectedActivityId,
    selectedPlateAppearanceId,
    pitchStatuses,
    onSelectPitch,
    onAddDetails,
    onMatchupClick,
  };

  return (
    <div data-testid="plate-appearance-feed-panel" className="space-y-6">
      <ActivePlateAppearance {...sharedProps} />
      <GameHistory {...sharedProps} />
    </div>
  );
};
